import React from "react";
import DocumentsComponent from "../../components/documents";
import Page from "../../components/vapor/page";

const DocumentsView = () => {
    return (
        <Page
            title={"DOCUMENTI ACQUISTATI"}
            subtitle={`Visualizza e scarica i documenti acquistati`}
        >
            <DocumentsComponent />
        </Page>
    );
};

export default DocumentsView;
